/* eslint-disable react-refresh/only-export-components */
import {Suspense} from 'react';
import * as Sentry from '@sentry/react';
import {withProfiler} from '@sentry/react';
import ChekinPro from './ChekinPro';
import AppRouter from './Routes';
import ScrollToTop from 'utils/scrollToTop';
import AppProviders from 'context/index';
import {SplashScreen} from 'components/SplashScreen';
import {ErrorFallback} from 'components/ErrorFallback';
import {ProcessToast} from 'components/common/ProcessToast';
import {IdleDetector} from 'components/sessions/IdleDetector';
import {LivenessModelPreloader} from 'components/LivenessDetection';
import {SuspenseLoader} from 'styled/common';

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({error}) => <ErrorFallback error={error} />}
      onError={ChekinPro.events.onError}
    >
      <AppProviders>
        <IdleDetector />
        <SplashScreen />
        <ScrollToTop />
        <LivenessModelPreloader />
        <Suspense fallback={<SuspenseLoader width={80} visible />}>
          <AppRouter />
        </Suspense>
        <ProcessToast />
      </AppProviders>
    </Sentry.ErrorBoundary>
  );
}

export default withProfiler(App);
